import axios from 'axios'

export const API_URL = process.env.REACT_APP_API_URL
export const http = axios.create({
  baseURL: API_URL,
})

http.interceptors.request.use(
  function (config) {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      config.headers.accessToken = user.access_token
      config.headers.userId = user.id
    }
    return config
  },
  function (error) {
    return error
  },
)

http.interceptors.response.use(
  function (response) {
    // console.log('response: ', response.data)
    if (response.data.code === 401) {
      localStorage.removeItem('user')
      window.location.href = '/login'
    } else if (response.data.code === 500) {
    }
    return response.data
  },
  function (error) {
    console.log('error: ', error)
    // dispatch(dispatchMessage('error', 'ผิดพลาด', 'ok'))
    return Promise.reject(error)
  },
)

export async function GET(url) {
  try {
    return await http.get(url)
  } catch (error) {
    if (error.response.status === 401) {
      window.location.href = '/logout'
    }
    console.log('http GET ERROR')
  }
}

export async function POST(url, data) {
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    return await http.post(`${url}`, data, {
      headers: { accessToken: `${user?.access_token}`, userId: `${user?.id}` },
    })
  } catch (error) {
    if (error.response.status === 401) {
      window.location.href = '/logout'
    }
    console.log('http GET ERROR')
  }
}

export async function PUT(url, data) {
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    return await http.put(`${url}`, data, {
      headers: { accessToken: `${user?.access_token}`, userId: `${user?.id}` },
    })
  } catch (error) {
    if (error.response.status === 401) {
      window.location.href = '/logout'
    }
    console.log('http GET ERROR')
  }
}

export async function DELETE(url) {
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    return await http.delete(`${url}`, {
      headers: { accessToken: `${user?.access_token}`, userId: `${user?.id}` },
    })
  } catch (error) {
    if (error.response.status === 401) {
      window.location.href = '/logout'
    }
    console.log('http GET ERROR')
  }
}
